export default __webpack_public_path__ + "static/media/JAS0190.34I-43645_-26084_0.ac0b046b.jpg";